<template>
  <label :for="id" class="label-profile position-relative">
    <div
      class="brand-wrapper d-flex justify-content-center align-items-center position-absolute top-0 start-0 bottom-0 end-0"
      v-if="loading ?? removeLogoLoading"
    >
      <RollingLoader />
    </div>
    <div
      class="edit-wrapper d-flex justify-content-center align-items-center position-absolute end-0"
    >
      <PencilIcon class="text-white" />
    </div>
    <input
      :id="id"
      accept="image/*"
      class="d-none"
      type="file"
      @change="onFileChange"
      data-testid="input-fileInput"
      ref="profilePictureRef"
    />
    <div class="img-wrapper d-flex justify-content-center align-items-center">
      <img
        v-if="imgSrc"
        class="imgSrc position-absolute w-100 h-100 align-items-center rounded-circle"
        style="border: 3px solid #e8eef4;"
        :src="imgSrc"
        :alt="id ?? 'profile'"
      />
      <div
        v-else
        class="camera-icon d-flex justify-content-center align-items-center bg-white"
      >
        <CameraIcon />
      </div>
    </div>
  </label>
</template>

<script lang="ts" setup>
import { ref, computed } from "vue";
import { useStore } from "vuex";

import { CameraIcon, PencilIcon } from "@/components/svg";

import { RollingLoader } from "@/components/global";

defineProps<{
  id: string;
  imgSrc: string;
  loading?: boolean;
}>();

const emit = defineEmits<(e: 'change', files: FileList) => void>();

const store = useStore();

const profilePictureRef = ref<HTMLInputElement | null>(null);
const removeLogoLoading = computed(() => store.getters["settings/removeLogoLoading"]);

const onFileChange = (e: Event) => {
  const files = (e.target as HTMLInputElement).files;
  if (files) {
    emit('change', files);
  }

  (e.target as HTMLInputElement).value = '';
};

defineExpose({ profilePictureRef });
</script>

<style scoped>
.label-profile {
  height: 5.5rem;
  width: 5.5rem;
  cursor: pointer;
}

.label-profile:hover img {
  opacity: 0.8;
}

.label-profile .edit-wrapper {
  height: 1.5rem;
  width: 1.5rem;
  background-color: var(--ch-blue-100);
  border-radius: 100%;
  top: 0.5rem;
  z-index: 10;
}

.label-profile .img-wrapper {
  height: 100%;
  width: 100%;
  background-color: #e8eef4;
  border-radius: 100%;
}

.label-profile .img-wrapper .camera-icon {
  width: 2.5rem;
  height: 2.5rem;
  border-radius: 100%;
}

.edit-wrapper:hover {
  opacity: 0.8;
}

.imgSrc {
  line-height: 50px;
}

.brand-wrapper {
  background: var(--ch-black-10);
  z-index: 50;
  border-radius: 100%;
}
</style>
